import { useEffect, useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';

export const useResponsiveQueries = {
  mobile: '(max-width: 1024px)',
  desktop: '(min-width: 1024px)',
  hover: '(hover: hover)',
  'pointer-fine': '(pointer: fine)',
  'pointer-coarse': '(pointer: coarse)',
  'prefers-reduced-motion': '(prefers-reduced-motion: reduce)',
} as const;

type QueryKey = keyof typeof useResponsiveQueries;
type UseMediaQueryOptions = Parameters<typeof useMediaQuery>[1];

export const useResponsive = (
  queryKey: QueryKey,
  options?: UseMediaQueryOptions
) => useMediaQuery(useResponsiveQueries[queryKey], options);

export const useHydrationSafeResponsive = (
  queryKey: QueryKey,
  options?: UseMediaQueryOptions
) => {
  const [matches, setMatches] = useState<boolean | undefined>(undefined);
  const wrappedMatch = useResponsive(queryKey, options);

  useEffect(() => {
    setMatches(wrappedMatch);
  }, [wrappedMatch]);

  return matches;
};
